<template>
  <div class="back-login">
    <router-link to="/login" class="back-link">
      <a-icon type="arrow-left" /> Voltar ao login
    </router-link>
  </div>
</template>

<script>
export default {
  name: "BackToLogin",
};
</script>

<style lang="scss" scoped>
.back-login {
  text-align: center;
  margin-top: 0px;

  .back-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #424242;
    font-weight: 600;
    gap: 8px;
    text-decoration: none;

    &:hover {
      color: #ff5722;
    }
  }
}
</style>
